/* eslint-disable */
 
 
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

// Registrar Service Worker para PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registrado: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registro falló: ', registrationError);
      });
  });
}

// Suprimir errores de extensiones del navegador desde el inicio
const originalError = console.error;
const originalWarn = console.warn;

console.error = (...args) => {
  const errorMessage = args.join(' ');
  
  // Suprimir errores específicos de extensiones
  if (
    errorMessage.includes('inpage.js') ||
    errorMessage.includes('Cannot read properties of null') ||
    errorMessage.includes('chrome-extension://') ||
    errorMessage.includes('moz-extension://') ||
    errorMessage.includes('extension://') ||
    errorMessage.includes('TypeError: Cannot read properties of null')
  ) {
    return; // No mostrar estos errores
  }
  
  originalError.apply(console, args);
};

console.warn = (...args) => {
  const warnMessage = args.join(' ');
  
  // Suprimir warnings específicos de extensiones
  if (
    warnMessage.includes('inpage.js') ||
    warnMessage.includes('chrome-extension://') ||
    warnMessage.includes('moz-extension://') ||
    warnMessage.includes('extension://')
  ) {
    return; // No mostrar estos warnings
  }
  
  originalWarn.apply(console, args);
};

// Manejador global para errores no capturados
window.addEventListener('error', (event) => {
  const error = event.error;
  const errorMessage = error?.message || error?.toString() || '';
  
  if (
    errorMessage.includes('inpage.js') ||
    errorMessage.includes('Cannot read properties of null') ||
    errorMessage.includes('chrome-extension://') ||
    errorMessage.includes('moz-extension://') ||
    errorMessage.includes('extension://') ||
    errorMessage.includes('TypeError: Cannot read properties of null')
  ) {
    event.preventDefault();
    return false;
  }
});

// Manejador para promesas rechazadas
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  const errorMessage = error?.message || error?.toString() || '';
  
  if (
    errorMessage.includes('inpage.js') ||
    errorMessage.includes('Cannot read properties of null') ||
    errorMessage.includes('chrome-extension://') ||
    errorMessage.includes('moz-extension://') ||
    errorMessage.includes('extension://') ||
    errorMessage.includes('TypeError: Cannot read properties of null')
  ) {
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'))
 
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)


reportWebVitals()
